import CRUD from './crud'

export default new CRUD('judge-profiles', 'superior-judge')
